import { api } from "./client";

export const rolesApi = {
  list: () => api.get("/roles").then((r) => r.data.roles),
  get: (id) => api.get(`/roles/${id}`).then((r) => r.data.role),
  create: (data) => api.post("/roles", data).then((r) => r.data.role),
  update: (id, data) => api.patch(`/roles/${id}`, data).then((r) => r.data.role),
  remove: (id) => api.delete(`/roles/${id}`).then((r) => r.data),
  setPermissions: (id, permissions) =>
    api
      .put(`/roles/${id}/permissions`, { permissions })
      .then((r) => r.data.role),
};
